export const getDivideResult = (num1, num2) => {
	const num1Normalize = +num1 !== Infinity && !isNaN(+num1) ? +num1 : 0
	const num2Normalize = +num2 !== Infinity && !isNaN(+num2) ? +num2 : 0
	return num2Normalize === 0 ? 0 : num1Normalize / num2Normalize
}
